import { Actions, SET_LOGGED } from "./actions";
import { State, initialState } from "./state";

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case SET_LOGGED:
      return Object.assign({}, state, { logged: action.logged });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/logged/reducer.ts